const sentryDns = 'https://2dd954865006a4653a39e64fe4d399f7@sentry.quix.it/135'

export const sharedEnvironment = {
  keycloakConfig: {
    realm: 'bi-nocore-apps',
    clientId: 'product-feedback-fe',
  },
  redirectUriApp: 'capacitor://localhost',
  deviceInfo: {
    appVersion: '',
    appBuild: '',
    appId: '',
    appName: '',
    operatingSystem: '',
    osVersion: '',
    platform: '',
    model: '',
    manufacturer: '',
    uuid: '',
    isVirtual: false,
  },
  production: false,
  baseUrl: '',
  isApp: false,
  domain: "https://productfeedbackquality.calzedonia.com",
  keycloakUrl: 'https://keycloak.dev.gcp.calzedonia.com',
  redirectUri: 'http://localhost:4200/',
  oktaRedirect: 'https://productfeedbackquality.calzedonia.com/auth/realms/quake/broker/samloktapf/endpoint',
  version: 'test',
  name: 'DEV ENVIRONMENT',
  minName: 'D',
  sentryName: 'DEV'
}

export const createSentryConfig = (
  tracesSampleRate: number,
  captureConsole: string[]
): { tracesSampleRate: number; captureConsole: string[]; dns: string } => ({
  tracesSampleRate,
  captureConsole,
  dns: sentryDns,
})
